import createReducer from '../../tools/createReducer'

import * as types from './types'

export const showMessage = createReducer(false, {
  [types.SHOW_MESSAGE](state, action) {
    return action.payload
  }
});
// 消息数量
export const messageCount = createReducer(false, {
  [types.MESSAGE_COUNT](state, action) {
    return action.payload
  }
});
// 未读消息统计（上述messageCount记录为状态，非数量...）
export const notifyCountObject = createReducer({}, {
  [types.NOTIFY_COUNT](state, action) {
    return Object.assign({}, state, action.payload)
  }
})
export const pathName = createReducer(null, {
  setPathName: function (state, action) {
    if (action.payload != "/groupInsSys/insList" && action.payload.indexOf("/groupInsSys/insDetails") == -1) {
      window.localStorage.removeItem('groupList');
      window.localStorage.removeItem('nameList');
      window.localStorage.removeItem('orgList');
      window.localStorage.removeItem('agencyId');
      window.localStorage.removeItem('names');
      window.localStorage.removeItem('companyName');
      window.localStorage.removeItem('ind')
    }
    return action.payload
  }
})
// 活动霸屏-轮播图-列表
export const activityList = createReducer([], {
  [types.ACTIVITY_ACTION](state, action) {
    return action.payload;
  }
});

// 霸屏记录
export const baPingStatus = createReducer(false, {
  [types.BAPING_ACTION](state, action) {
    return action.payload;
  }
})

// 推广费小数点
export const feeDecimal = createReducer(false, {
  [types.DECIMAL_ACTION](state, action) {
    return isNaN(action.payload) ? 0 : action.payload;
  }
})

// 菜单ID列表
export const menuIds = createReducer([], {
  [types.ADD_MENU_ID](state, action) {
    return action.list;
  }
});
